/** Route the business Contacts tabs are relative to. */
export const EDITOR_CONTACTS_ROUTE = 'editorcontact';

/**
 * The business Contacts tabs. Shared by the page and the hover sub-navigation.
 * Guests (role 4) do not see the Kuba Norge contacts.
 * @param roleId Current role id (`BaseServices.roleId`).
 */
export function editorContactTabs(
  roleId: string
): { linkText: string; translationKey: string }[] {
  const tabs = [{ linkText: 'list', translationKey: 'CONTACTS' }];
  if (roleId !== '4') {
    tabs.push({ linkText: 'our', translationKey: 'KUBA_NORGE' });
  }
  return tabs;
}
